module.exports = __webpack_public_path__ + "static/img/银泰百货.b61040b7.png";